import { HumanMaleMaleIcon } from './HumanMaleMaleIcon';

/**
 * author: Henrique César Madeira
 * id AB5B56A8-CB56-4502-B388-BA02ECEB2D1A
 * name human-male-male
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-male.svg
 * tags
 * - People / Family 
 */
export const ManManIcon = HumanMaleMaleIcon;
export default ManManIcon